import { render, staticRenderFns } from "./OTCOrderList.vue?vue&type=template&id=b3130b36&scoped=true&"
import script from "./OTCOrderList.vue?vue&type=script&lang=js&"
export * from "./OTCOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3130b36",
  null
  
)

export default component.exports